// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#6F7881"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.66406 5.83203L8.46816 10.5949C9.01914 10.9806 9.29463 11.1734 9.59428 11.2481C9.85897 11.3141 10.1358 11.3141 10.4005 11.2481C10.7002 11.1734 10.9757 10.9806 11.5266 10.5949L18.3307 5.83203M5.66406 16.6654H14.3307C15.7309 16.6654 16.4309 16.6654 16.9657 16.3929C17.4361 16.1532 17.8186 15.7707 18.0582 15.3003C18.3307 14.7656 18.3307 14.0655 18.3307 12.6654V7.33203C18.3307 5.9319 18.3307 5.23183 18.0582 4.69705C17.8186 4.22665 17.4361 3.8442 16.9657 3.60451C16.4309 3.33203 15.7309 3.33203 14.3307 3.33203H5.66406C4.26393 3.33203 3.56387 3.33203 3.02909 3.60451C2.55868 3.8442 2.17623 4.22665 1.93655 4.69705C1.66406 5.23183 1.66406 5.9319 1.66406 7.33203V12.6654C1.66406 14.0655 1.66406 14.7656 1.93655 15.3003C2.17623 15.7707 2.55868 16.1532 3.02909 16.3929C3.56387 16.6654 4.26393 16.6654 5.66406 16.6654Z"
    />
  </svg>
);
const IconEmail = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconEmail;
